// SettingsPage.tsx
import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Typography,
  Box,
  useMediaQuery,
  useTheme,
  SvgIcon,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import {
  AccountCircle,
  Feedback,
  Restore,
  CreditCard,
  Delete,
} from "@mui/icons-material";
import "./Setting.scss";
import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";
import TextInputFieldC from "../../Components/TextInput/TextInputFieldC";
import TextAreaInputField from "../../Components/TextAreaInput/TextAreaInputField";
import { ExpandMore, Link as LinkIcon } from "@mui/icons-material";
import { ReactComponent as Biling } from "./SettingImage/Bilingpage.svg";
import { ReactComponent as Feedbackpage } from "./SettingImage/Feedbackpage.svg";
import { ReactComponent as Profilepage } from "./SettingImage/Profilepage.svg";
import { ReactComponent as Resetpage } from "./SettingImage/Resetpage.svg";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { listRegion } from "../../Redux/Slices/User/ListRegionSlice";
import { listYearGroup } from "../../Redux/Slices/User/ListYearGroupSlice";
import { clearListuser, listUser } from "../../Redux/Slices/User/ListUserSlice";
import { EditStudentExamPractice } from "../../Redux/Slices/StudentExamPractice/EditStudentExamPracticeSlice";
import { EditStudentExam } from "../../Redux/Slices/StudentExam/EditStudentExamSlice";
import { z } from "zod";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { IUser } from "../User/IUser";
import {
  clearEditUserResponse,
  EditUser,
} from "../../Redux/Slices/User/EditUserSlice";
import {
  addUser,
  clearAddUserResponse,
} from "../../Redux/Slices/User/AddUserSlice";
import Snackbar from "../../Components/Snackbar/Snackbar";
import NumberInputField from "../../Components/NumberInput/NumberInputField";
import Select from "../../Components/Select/AutoComplete";
import { AutocompleteOption } from "../../Components/Select/ISelectProps";
import ButtonField from "../../Components/Button/ButtonField";
import { Isettingfeedback } from "./ISetting";
import {
  clearSettingResetMockResponse,
  listSettingResetMock,
} from "../../Redux/Slices/Setting/ListListSettingResetMockSlice";
import {
  addSetting,
  clearAddSettingResponse,
} from "../../Redux/Slices/Setting/AddSettingSlice";
import {
  clearSettingResetResponse,
  listSettingReset,
} from "../../Redux/Slices/Setting/ListSettingResetSlice";
import { listBilling } from "../../Redux/Slices/Billing/ListBillingSlice";
import { useNavigate } from "react-router-dom";
import { clearListSubscription } from "../../Redux/Slices/Subscription/ListSubscriptionSlice";
import Menus from "../../Components/Menu/Menu";
import { clearLoginStatus } from "../../Redux/Slices/LoginSlicer/LoginSlicer";
import IconButtonField from "../../Components/Button/IconButtonField";
import Avatars from "../../Components/Avatar/Avatars";
import { useBlocker } from "react-router-dom";
import { listYearlevel_map } from "../../Redux/Slices/Yearlevel_map/ListYearlevel_mapSlice";
import { clearDashboardChart } from "../../Redux/Slices/DashboardChart/DashboardChart";

const SettingsPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // student profile
  const dispatch = useAppDispatch();
  const [openProfile, setOpenProfile] = useState(false);

  const AddSettingSliceLoading = useAppSelector(
    (state) => state.AddSettingSlice
  );
  const ListSettingResetMockSliceLoading = useAppSelector(
    (state) => state.ListSettingResetMockSlice
  );
  const ListSettingResetSliceLoading = useAppSelector(
    (state) => state.ListSettingResetSlice
  );
  const ListBillingSlices = useAppSelector((state) => state.ListBillingSlice);
  const Billing: any = ListBillingSlices?.data?.data;
  const Listslices: any = ListBillingSlices?.data;
  console.log(ListBillingSlices);

  const AddUserSliceLoading = useAppSelector((state) => state.AddUserSlice);
  const EditUserSliceLoading = useAppSelector((state) => state.EditUserSlice);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(listBilling());
    dispatch(listRegion());
    dispatch(listYearlevel_map());
    dispatch(listYearGroup());
    dispatch(clearAddSettingResponse());
    dispatch(clearEditUserResponse());
    dispatch(clearAddUserResponse());
    dispatch(clearSettingResetResponse());
    dispatch(clearSettingResetMockResponse());
  }, [dispatch]);
  useEffect(() => {
    dispatch(listUser());
  }, [dispatch, AddUserSliceLoading, EditUserSliceLoading]);

  const { data: ListUserSliceLoading } = useAppSelector(
    (state) => state.ListUserSlice
  );

  const ListUser: any = Array.isArray(ListUserSliceLoading?.data)
    ? ListUserSliceLoading?.data.map((user, index) => ({
        ...user,
        index: index + 1,
      }))
    : [];
  const ListYearSliceLoading = useAppSelector(
    (state) => state.ListYearGroupSlice
  );
  const ListYear = ListYearSliceLoading?.data;

  const YearList = Array.isArray(ListYear?.data)
    ? ListYear?.data?.map((listExams) => ({
        label: listExams?.year_group!,
        value: listExams?.year_group,
      }))
    : [];

  const ListRegionSliceLoading = useAppSelector(
    (state) => state.ListRegionSlice
  );
  const ListRegion = ListRegionSliceLoading?.data;

  const RegionList = Array.isArray(ListRegion?.data)
    ? ListRegion?.data?.map((listExams) => ({
        label: listExams?.state!,
        value: listExams?.state,
      }))
    : [];
  // Status list
  const RoleSatus = [
    {
      label: "Active",
      value: true,
    },

    {
      label: "Inactive",
      value: false,
    },
  ];
  // const userSchema = z.object({
  //   id: z.number().optional(),
  //   student_name: z
  //     .string({ message: "Please enter name" })
  //     .min(1, { message: "Please enter name" }),
  //   parent_name: z
  //     .string({ message: "Please enter parent name" })
  //     .min(1, { message: "Please enter parent name" }),
  //   email: z
  //     .string({
  //       required_error: "Please enter a valid email ID",
  //       message: "Please enter a valid email ID",
  //     })
  //     .email({
  //       message: "Please enter a valid email ID",
  //     }),
  //   phone_no: z
  //     .number({ message: "Please enter phone number" })
  //     .nonnegative({ message: "Phone number must be exactly 10 digits" }),
  //   // .refine(
  //   //   (value) =>
  //   //     value.toString().length <= 10 && value.toString().length >= 10,
  //   //   {
  //   //     message: "Phone number must contain only 10 digits",
  //   //   }
  //   // ),
  //   hear_about_us: z
  //     .string({ message: "Please enter hear about us" })
  //     .min(1, { message: "Please enter hear about us" }),

  //   state: z.string({ message: "Please select state" }),
  //   year_group: z.string({ message: "Please select year group" }),
  //   status: z.boolean({
  //     message: "Please select the status",
  //   }),
  // });
  // const methods = useForm<IUser>({
  //   // defaultValues: initialValues,
  //   resolver: zodResolver(userSchema),
  //   mode: "onChange",
  // });

  // const onSubmit: SubmitHandler<IUser> = (val) => {
  //   if (val.id) {
  //     dispatch(EditUser({ ...val, phone_no: String(val.phone_no) }));
  //   } else {
  //     dispatch(addUser({ ...val, phone_no: String(val.phone_no) }));
  //   }
  // };

  // useEffect(() => {
  //   return () => {
  //     methods.reset();
  //   };
  // }, [dispatch]);

  // useEffect(() => {
  //   methods.reset({ ...ListUser[0] });
  // }, [ListUserSliceLoading]);

  // const formRef = React.useRef<HTMLFormElement>(null);
  // const feedbackFormRef = React.useRef<HTMLFormElement>(null);

  // feedback
  // const userSchemafeedback = z.object({
  //   id: z.number().optional(),
  //   subject: z.string().optional(),
  //   feedback: z.string().optional(),
  // });
  // const methodsfeedback = useForm<Isettingfeedback>({
  //   // defaultValues: initialValues,
  //   resolver: zodResolver(userSchemafeedback),
  //   mode: "onChange",
  // });
  // const handleSubmitfeedback: SubmitHandler<Isettingfeedback> = (val) => {

  //   dispatch(addUser({ ...val, status: true }));
  // };
  // Form refs
  const feedbackFormRef = React.useRef<HTMLFormElement>(null);

  // Validation Schemas
  const userSchema = z.object({
    id: z.number().optional(),
    student_name: z
      .string({ message: "Please enter name" })
      .min(1, { message: "Please enter name" }),
    parent_name: z
      .string({ message: "Please enter parent name" })
      .min(1, { message: "Please enter parent name" }),
    email: z
      .string({
        required_error: "Please enter a valid email ID",
        message: "Please enter a valid email ID",
      })
      .email({
        message: "Please enter a valid email ID",
      }),
    phone_no: z
      .number({ message: "Please enter phone number" })
      .nonnegative({ message: "Phone number must be exactly 10 digits" }),
    // .refine(
    //   (value) =>
    //     value.toString().length <= 10 && value.toString().length >= 10,
    //   {
    //     message: "Phone number must contain only 10 digits",
    //   }
    // ),
    hear_about_us: z
      .string()
      .min(1, { message: "Please enter hear about us" })
      .optional()
      .or(z.literal("")), // allow empty string

    // state: z.string({ message: "Please select state" }),

    yeargroup_country_map_id: z.number({ message: "Please select year group" }),
    // status: z.boolean({
    //   message: "Please select the status",
    // }),
  });

  const userSchemafeedback = z.object({
    id: z.number().optional(),
    subject: z.string({ message: "Please enter Section name" }),
    feedback: z.string({ message: "Please enter feedback" }),
  });

  // React Hook Form Methods
  const methods = useForm<IUser>({
    resolver: zodResolver(userSchema),
    // mode: "onChange",
  });

  const methodsfeedback = useForm<Isettingfeedback>({
    resolver: zodResolver(userSchemafeedback),
    mode: "onChange",
  });

  // Submit Handlers
  const onSubmit: SubmitHandler<IUser> = (val) => {
    console.log(val);

    if (val.id) {
      dispatch(EditUser({ ...val, phone_no: String(val.phone_no) }));
    } else {
      dispatch(addUser({ ...val, phone_no: String(val.phone_no) }));
    }
  };

  const handleSubmitfeedback: SubmitHandler<Isettingfeedback> = (val) => {
    dispatch(addSetting({ ...val, status: true }));
    dispatch(clearAddSettingResponse());
    methodsfeedback.reset({
      subject: "",
      feedback: "",
    });
  };

  // Reset form when data changes
  useEffect(() => {
    if (ListUser && ListUser.length > 0) {
      const user = {
        ...ListUser[0],
        phone_no: Number(ListUser[0].phone_no), // 👈 convert to string explicitly
      };
      methods.reset(user);
    }
  }, [ListUserSliceLoading]);

  const user = ListUser[0];
  const shouldBlock =
    !user ||
    user?.yeargroup_country_map_id === null ||
    user?.yeargroup_country_map_id === undefined ||
    user?.yeargroup_country_map_id === "" ||
    user?.yeargroup_country_map_id === 0;

  // This hook blocks route navigation
  const blocker = useBlocker(shouldBlock);

  useEffect(() => {
    if (blocker.state === "blocked" && shouldBlock) {
      blocker.reset();
      setOpenProfile(true);
    }
  }, [blocker, shouldBlock]);

  useEffect(() => {
    return () => {
      methods.reset();
      methodsfeedback.reset();
    };
  }, [dispatch]);
  const profileFormRef = React.useRef<HTMLFormElement>(null);

  // popup message
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const [openreset, setOpenreset] = React.useState(false);
  const handleClosereset = () => {
    setOpenreset(false);
  };

  // // popup remove
  // useEffect(() => {
  //   if (AddUserSliceLoading?.data) {
  //     const timer = setTimeout(() => {
  //       dispatch(clearAddUserResponse());
  //     }, 3000); // or however long your Snackbar is open
  //     return () => clearTimeout(timer);
  //   }
  // }, [AddUserSliceLoading?.data, dispatch]);
  // useEffect(() => {
  //   if (EditUserSliceLoading?.data) {
  //     const timer = setTimeout(() => {
  //       dispatch(clearEditUserResponse());
  //     }, 3000); // or however long your Snackbar is open
  //     return () => clearTimeout(timer);
  //   }
  // }, [EditUserSliceLoading?.data, dispatch]);

  // useEffect(() => {
  //   if (AddSettingSliceLoading?.data) {
  //     const timer = setTimeout(() => {
  //       dispatch(clearAddSettingResponse());
  //     }, 3000); // or however long your Snackbar is open
  //     return () => clearTimeout(timer);
  //   }
  // }, [AddSettingSliceLoading?.data, dispatch]);

  const { data: listYearlevel_maps } = useAppSelector(
    (state) => state.ListYearlevel_mapSlice
  );

  const ListYearLevel = Array.isArray(listYearlevel_maps?.data)
    ? listYearlevel_maps?.data?.map((listQuestions) => ({
        label:
          `${listQuestions?.yeargroup?.name}-${listQuestions?.region?.name}-${listQuestions?.region?.state}`!,
        value: listQuestions.id,
      }))
    : [];
  console.log(methods.formState.errors);

  return (
    <>
      {AddUserSliceLoading?.data?.message && (
        <Snackbar response={AddUserSliceLoading?.data} />
      )}
      {EditUserSliceLoading?.data?.message && (
        <Snackbar response={EditUserSliceLoading.data} />
      )}
      {ListSettingResetSliceLoading?.data?.message && (
        <Snackbar response={ListSettingResetSliceLoading.data} />
      )}
      {ListSettingResetMockSliceLoading?.data?.message && (
        <Snackbar response={ListSettingResetMockSliceLoading.data} />
      )}
      {AddSettingSliceLoading?.data?.message && (
        <Snackbar response={AddSettingSliceLoading.data} />
      )}

      <div className="SettingStudentAlingment">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <div>
            <div className="DashboardStudent">Setting</div>
            <div className="StudentPractice">
              Manage your account settings and preferences
            </div>
          </div>
          <div>
            <Menus
              menuItems={[
                // {
                //   menu: "Profile",
                //   onClick: () => {
                //     nav("/studentprofile");
                //   },
                // },
                {
                  menu: "Logout",
                  onClick: () => {
                    sessionStorage.clear();
                    dispatch(clearListuser());
                    dispatch(clearLoginStatus());
                    dispatch(clearDashboardChart());
                    navigate("/login");
                  },
                },
              ]}
            >
              <IconButtonField onClick={() => {}}>
                <Avatars sx={{ height: "2rem", width: "2rem" }} />
              </IconButtonField>
            </Menus>
            <span className="Username">{ListUser[0]?.student_name}</span>
          </div>
        </div>
        <Box maxWidth="1100px" mx="auto">
          {/* Profile */}
          <Accordion
            defaultExpanded={
              ListUser.length === 0 ||
              ListUser[0]?.yeargroup_country_map_id === null ||
              ListUser[0]?.yeargroup_country_map_id === "" ||
              ListUser[0]?.yeargroup_country_map_id === 0
            }
            disableGutters
            sx={{
              mb: 2,
              padding: "15px",
              border: "1px  solid #e2e8f0",

              borderRadius: "8px",
              boxShadow: "none",
              "&:first-of-type": {
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px",
              },
              "&::before": {
                display: "none", // ⬅️ This removes the background line
              },
            }}
          >
            <AccordionSummary
              sx={{ padding: "0px", alignItems: "center", display: "flex" }}
              expandIcon={<ExpandMore sx={{ fontSize: "2.3rem" }} />}
            >
              <SvgIcon
                component={Profilepage}
                sx={{ fill: "none", marginRight: "15px" }}
              />
              <Typography variant="subtitle1" className="settingname">
                Profile
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <FormProvider {...methods}>
                <form
                  ref={profileFormRef}
                  onSubmit={methods.handleSubmit(onSubmit)}
                  style={{ width: "100%" }}
                >
                  <div className="form_contents">
                    <div>
                      <div className="fieldname">Student Name *</div>
                      <TextInputFieldC
                        name="student_name"
                        sx={{ width: "100%" }}
                      />
                    </div>
                    <div>
                      <div className="fieldname">Parent Name *</div>
                      <TextInputFieldC
                        name="parent_name"
                        sx={{ width: "100%" }}
                      />
                    </div>
                    <div>
                      <div className="fieldname">Email Id *</div>

                      <TextInputFieldC name="email" sx={{ width: "100%" }} />
                    </div>
                    <div>
                      <div className="fieldname">Phone Number *</div>

                      <NumberInputField
                        name="phone_no"
                        type="number"
                        disabledScrollBar
                        sx={{ width: "100%" }}
                      />
                    </div>
                    <div>
                      <div className="fieldname">
                        How did you hear about us?
                      </div>

                      <TextInputFieldC
                        name="hear_about_us"
                        sx={{ width: "100%" }}
                      />
                    </div>
                    {/* <div>
                      <div className="fieldname">State</div>

                      <Select
                        name="state"
                        options={RegionList ?? []}
                        value={
                          RegionList?.find(
                            (list) => list.value === methods.getValues("state")
                          ) ?? null
                        }
                        onChange={(_, value) => {
                          const val = value as AutocompleteOption;
                          methods.setValue("state", val?.value, {
                            shouldValidate: true,
                          });
                        }}
                        sx={{ width: "100%" }}
                      />
                    </div> */}
                    <div>
                      <div className="fieldname">Year Group *</div>

                      <Select
                        name="yeargroup_country_map_id"
                        // label="Select  the Year group "
                        options={ListYearLevel ?? []}
                        value={
                          ListYearLevel?.find(
                            (list) =>
                              list.value ===
                              methods.getValues("yeargroup_country_map_id")
                          ) ?? null
                        }
                        onChange={(_, value) => {
                          const val = value as AutocompleteOption;
                          methods.setValue(
                            "yeargroup_country_map_id",
                            val?.value,
                            {
                              shouldValidate: true,
                            }
                          );
                        }}
                      />
                    </div>
                    {/* <div>
                      <div className="fieldname">Status</div>

                      <Select
                        name="status"
                        options={RoleSatus}
                        value={
                          RoleSatus?.find(
                            (role) => role.value === methods.getValues("status")
                          ) ?? null
                        }
                        onChange={(_, value) => {
                          const val = value as AutocompleteOption;
                          methods.setValue("status", val?.value ?? false);
                        }}
                        sx={{ width: "100%" }}
                      />
                    </div> */}
                  </div>
                  <Button
                    sx={{
                      alignSelf: isMobile ? "stretch" : "flex-start",
                      backgroundColor: "#009DFF",
                      color: "#fff",
                      textTransform: "none",
                      fontSize: "15px",
                      marginTop: "20px",
                      "&:hover": {
                        backgroundColor: "#009DFF",
                      },
                    }}
                    onClick={() => profileFormRef.current?.requestSubmit()}
                  >
                    Save Changes
                  </Button>
                  <div
                    style={{ color: "#BD0000", padding: "10px 10px 10px 0px" }}
                  >
                    {ListUser.length === 0 ||
                    ListUser[0]?.year_group === null ||
                    ListUser[0]?.year_group === ""
                      ? " Please update your profile/year level to ensure accurate exam assignment."
                      : ""}
                  </div>{" "}
                </form>
              </FormProvider>
            </AccordionDetails>
          </Accordion>

          {/* Feedback */}
          <Accordion
            sx={{
              mb: 2,
              borderRadius: "8px",
              padding: "15px",
              border: "1px  solid #e2e8f0",
              boxShadow: "none",
              "&::before": {
                display: "none", // ⬅️ This removes the background line
              },
            }}
          >
            <AccordionSummary
              sx={{ padding: "0px", alignItems: "center", display: "flex" }}
              expandIcon={<ExpandMore sx={{ fontSize: "2.3rem" }} />}
            >
              <SvgIcon
                component={Feedbackpage}
                sx={{ marginRight: "15px" }}
                inheritViewBox
              />
              <Typography variant="subtitle1" className="settingname">
                Feedback
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <FormProvider {...methodsfeedback}>
                <form
                  ref={feedbackFormRef}
                  // className="form_content"
                  style={{ padding: "0px 3%" }}
                  onSubmit={methodsfeedback.handleSubmit(handleSubmitfeedback)}
                >
                  <div>
                    <div className="fieldname">Section Name</div>
                    <TextInputFieldC
                      name="subject"
                      sx={{ width: "100%", marginBottom: "10px" }}
                    />
                  </div>
                  <div>
                    <div className="fieldname">Feedback</div>
                    <TextAreaInputField
                      name="feedback"
                      placeholder="Enter the feedback"
                      rows={3}
                      sx={{ width: "100%", marginBottom: "20px" }}
                    />
                  </div>

                  <Button
                    onClick={() => feedbackFormRef.current?.requestSubmit()}
                    variant="contained"
                    sx={{
                      alignSelf: isMobile ? "stretch" : "flex-start",
                      backgroundColor: "#009DFF",
                      color: "#fff",
                      textTransform: "none",
                      fontSize: "15px",
                      "&:hover": {
                        backgroundColor: "#009DFF",
                      },
                    }}
                  >
                    Submit Feedback
                  </Button>
                </form>
              </FormProvider>
            </AccordionDetails>
          </Accordion>

          {/* Reset Progress */}
          <Accordion
            sx={{
              mb: 2,
              borderRadius: "8px",
              padding: "15px",
              border: "1px  solid #e2e8f0",
              boxShadow: "none",
              "&::before": {
                display: "none", // ⬅️ This removes the background line
              },
            }}
          >
            <AccordionSummary>
              <Box
                sx={{
                  padding: "0px",
                  width: "100%",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <SvgIcon
                    component={Resetpage}
                    sx={{ fill: "none", marginRight: "15px" }}
                  />
                  <Typography variant="subtitle1" className="settingname">
                    Reset Progress
                  </Typography>
                </div>
                <Typography color="#4b5563" className="settingnames">
                  This action will reset all your progress, including completed
                  questions and statistics.
                </Typography>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    className="resetl"
                    onClick={() => {
                      setOpen(true);

                      // dispatch(listSettingResetMock());
                    }}
                  >
                    Reset Exams
                  </Button>
                  <Button
                    className="resetall"
                    onClick={() => {
                      setOpenreset(true);
                      // dispatch(listSettingReset());
                    }}
                  >
                    Reset All Progress
                  </Button>
                </div>
              </Box>
            </AccordionSummary>
          </Accordion>

          {/* Billing */}
          <Accordion
            sx={{
              mb: 2,
              padding: "15px",
              borderRadius: "8px",
              border: "1px  solid #e2e8f0",
              boxShadow: "none",
              "&:first-of-type": {
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px",
              },
              "&::before": {
                display: "none", // ⬅️ This removes the background line
              },
            }}
          >
            <AccordionSummary
              sx={{ padding: "0px", alignItems: "center", display: "flex" }}
              expandIcon={<ExpandMore sx={{ fontSize: "2.3rem" }} />}
            >
              <SvgIcon
                component={Biling}
                sx={{ fill: "none", marginRight: "15px" }}
              />
              <Typography variant="subtitle1" className="settingname">
                Billing
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Box
                display="flex"
                flexDirection={isMobile ? "column" : "row"}
                justifyContent="space-between"
                alignItems={isMobile ? "flex-start" : "center"}
                gap={2}
                width="100%"
              >
                <Box
                  display="flex"
                  flexDirection="column"
                  width="100%"
                  sx={{ marginBottom: "20px" }}
                  gap={1}
                >
                  <Box display="flex" alignItems="center" gap={1}>
                    <div className="Subscription">
                      <Typography sx={{ fontSize: "15px" }}>
                        Subscription Status
                      </Typography>
                    </div>
                    <Chip
                      label={
                        Billing?.subscription_status === true
                          ? "Active"
                          : "Inactive"
                      }
                      size="small"
                      sx={{
                        fontSize: "16px",
                        bgcolor:
                          Billing?.subscription_status === true
                            ? "green"
                            : "#FFD6D6",
                        color:
                          Billing?.subscription_status === true
                            ? "white"
                            : "#D32F2F",
                        borderRadius: "12px", // ✅ Add this line
                      }}
                    />
                  </Box>
                  <Box display="flex" alignItems="center" gap={1}>
                    <Typography
                      className="Subscription"
                      sx={{ fontSize: "15px" }}
                    >
                      Plan
                    </Typography>
                    <Typography
                      color="text.secondary"
                      variant="body2"
                      sx={{ fontSize: "15px" }}
                    >
                      {Billing?.subscription_status === true
                        ? "Premium"
                        : "Free"}
                    </Typography>
                  </Box>
                  <Box display="flex" alignItems="center" gap={1}>
                    <Typography
                      className="Subscription"
                      sx={{ fontSize: "15px" }}
                    >
                      Next Billing Date
                    </Typography>
                    <Typography
                      color="text.secondary"
                      variant="body2"
                      sx={{ fontSize: "15px" }}
                    >
                      {Listslices?.status === false ||
                      Billing?.end_date === null
                        ? "NA"
                        : new Date(Billing?.end_date).toLocaleString()}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#009DFF",
                  color: "#fff",
                  px: 3,
                  py: 1.2,
                  mt: isMobile ? 2 : 0,
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: "16px",
                  "&:hover": {
                    backgroundColor: "#009DFF", // slightly darker blue on hover
                  },
                }}
                onClick={() => {
                  dispatch(clearListSubscription());
                  navigate("/totalexam");
                }}
              >
                Manage Subscription
              </Button>
            </AccordionDetails>
          </Accordion>
        </Box>
      </div>
      <React.Fragment>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            sx={{
              display: "flex",
              justifyItems: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <ReportGmailerrorredIcon
              sx={{ fontSize: "50px", color: "#009dff" }}
            />
            <div style={{ fontSize: "20px", color: "#009dff" }}>Warning</div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              sx={{ fontSize: "15px" }}
            >
              This action will clear all your pending exam and practice test
              attempts and return them to their initial state. Any progress made
              will be lost. Are you sure you want to reset the exams?
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
            <ButtonField
              className="form_save_button"
              onClick={() => {
                dispatch(listSettingResetMock());
                setOpen(false);
              }}
            >
              Yes
            </ButtonField>
            <ButtonField
              className="form_cancel_button"
              onClick={() => setOpen(false)}
            >
              No
            </ButtonField>
          </DialogActions>
        </Dialog>
      </React.Fragment>
      <React.Fragment>
        <Dialog
          open={openreset}
          onClose={handleClosereset}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            sx={{
              display: "flex",
              justifyItems: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <ReportGmailerrorredIcon
              sx={{ fontSize: "50px", color: "#009dff" }}
            />
            <div style={{ fontSize: "20px", color: "#009dff" }}>Warning</div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              sx={{ fontSize: "15px" }}
            >
              This action will permanently delete all your progress, including
              exam results, practice test results, and dashboard statistics.
              This cannot be undone. Are you sure you want to reset all
              progress?
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
            <ButtonField
              className="form_save_button"
              onClick={() => {
                dispatch(listSettingReset());
                setOpenreset(false);
              }}
            >
              Yes
            </ButtonField>
            <ButtonField
              className="form_cancel_button"
              onClick={() => setOpenreset(false)}
            >
              No
            </ButtonField>
          </DialogActions>
        </Dialog>
      </React.Fragment>

      <React.Fragment>
        <Dialog
          open={openProfile}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            sx={{
              display: "flex",
              justifyItems: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <ReportGmailerrorredIcon
              sx={{ fontSize: "50px", color: "#009dff" }}
            />
            <div style={{ fontSize: "20px", color: "#009dff" }}>
              {" "}
              Please update Profile
            </div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              sx={{ fontSize: "15px" }}
            >
              Please update your profile/year level to ensure accurate exam
              assignment.
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
            <button
              className="card-buttonexam"
              onClick={() => {
                setOpenProfile(false);
              }}
            >
              Update profile
            </button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    </>
  );
};

export default SettingsPage;
